module.exports = __webpack_public_path__ + "479e418448e976daa97045b866213e71.png";